/**
 * Turn axios/API errors into a short user-facing message.
 * Handles JSON bodies and Django HTML debug pages (e.g. IntegrityError).
 */
export function parseApiErrorMessage(err, fallback = 'Something went wrong. Please try again.') {
  if (!err?.response) {
    if (err?.code === 'ECONNABORTED' || err?.message?.includes('timeout')) {
      return 'Request timed out. Please try again.';
    }
    if (err?.message?.includes('Network Error') || err?.message?.includes('ERR_NETWORK')) {
      return 'Network error: unable to reach the server.';
    }
    return err?.message || fallback;
  }

  const { status, data } = err.response;

  if (status === 401) {
    return 'Authentication failed. Please log in again.';
  }

  if (typeof data === 'string') {
    if (data.includes('IntegrityError')) {
      return 'A user with this email or phone number already exists.';
    }
    const titleMatch = data.match(/<title>([^<]+)<\/title>/i);
    if (titleMatch) {
      const title = titleMatch[1].trim();
      if (/IntegrityError/i.test(title)) {
        return 'A user with this email or phone number already exists.';
      }
      return title;
    }
    if (data.trim().startsWith('<')) {
      return fallback;
    }
    return data.length > 200 ? fallback : data;
  }

  if (data?.detail) {
    return typeof data.detail === 'string' ? data.detail : JSON.stringify(data.detail);
  }

  if (data?.message) {
    return data.message;
  }

  if (status === 400 && data && typeof data === 'object') {
    const fieldErrors = Object.entries(data)
      .map(([field, messages]) => {
        const msg = Array.isArray(messages) ? messages[0] : String(messages);
        return `${field}: ${msg}`;
      })
      .join(', ');
    if (fieldErrors) return fieldErrors;
  }

  return fallback;
}
